import React from 'react';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '../components/ui/accordion';
import faqData from '../data/faq.json';
import PageHero from '../components/PageHero';

const FAQ = () => {
  return (
    <div className="relative">
      <PageHero 
        title={faqData.pageTitle}
        subtitle={faqData.pageSubtitle}
      />

      <section className="section-padding pt-0">
        <div className="max-w-3xl mx-auto">
          {faqData.categories.map((category, catIndex) => (
            <div key={catIndex} className="mb-12" data-testid={`faq-category-${catIndex}`}>
              <h2 className="text-xl font-semibold text-white mb-6">
                {category.title}
              </h2>
              
              <Accordion type="single" collapsible className="space-y-3">
                {category.questions.map((item, index) => (
                  <AccordionItem 
                    key={index} 
                    value={`${catIndex}-${index}`}
                    className="glass-panel px-6 border border-white/10 rounded-xl overflow-hidden"
                  >
                    <AccordionTrigger 
                      className="text-left text-white hover:text-violet-300 transition-colors py-5 hover:no-underline"
                      data-testid={`faq-question-${catIndex}-${index}`}
                    >
                      {item.question}
                    </AccordionTrigger>
                    <AccordionContent className="text-slate-400 pb-5 leading-relaxed">
                      {item.answer}
                    </AccordionContent>
                  </AccordionItem>
                ))}
              </Accordion>
            </div>
          ))}
        </div>
      </section>

      {/* Still have questions */}
      <section className="section-padding cosmic-bg">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-2xl md:text-3xl font-bold text-white mb-4">
            Still have questions?
          </h2>
          <p className="text-slate-400 mb-8">
            We're here to help. Reach out and we'll get back to you.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a 
              href="/contact" 
              className="btn-primary"
              data-testid="faq-contact-cta"
            >
              Contact Us
            </a>
            <a 
              href="/#early-access" 
              className="btn-ghost"
              data-testid="faq-access-cta"
            >
              Get Early Access
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default FAQ;
